<template>
  <div class="card">
    <Loader :is-loading="loading">
      <div class="d-flex flex-column-fluid"> 
        <div class="container">
          <div class="card card-custom">
            <div class="card-header py-3">
              <div class="card-title align-items-start flex-column">
                <h3 class="card-label font-weight-bolder text-dark"><i class="fas fa-user mb-4"> </i> {{ user.lastname }} {{ user.firstname }}</h3>
                <h3 class="card-label font-weight-bolder text-dark"><i class="bi bi-shield-check"> </i> {{ user.roles?.[0].name }}</h3>
              </div>
            </div>
            <div class="card-body" style="padding: 2rem 0rem !important;">
              <div class="accordion accordion-light accordion-toggle-arrow" id="accordionExample1">
                  <div class="accordion" id="kt_accordion_1">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="kt_accordion_11_header_1">
                        <button class="accordion-button fs-4 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_11_body_1" aria-expanded="true" aria-controls="kt_accordion_11_body_1">
                          {{ $t('right.general_permission') }}
                        </button>
                      </h2>
                      <div id="kt_accordion_11_body_1" class="accordion-collapse collapse show" aria-labelledby="kt_accordion_11_header_1" data-bs-parent="#kt_accordion_11">
                        <div class="accordion-body" style="background-color: #0072CE0D;">
                          <form class="form mb-4" v-for="(right, index) in rights" :key="index">
                              <h5 class="card shadow-sm p-3" style="width: 220px;">{{ $t(right.name) }} </h5>
                              <div class="row">
                                <div class="form-group col-12 col-md-6 col-lg-6" v-for="(item, key) in right.items" :key="key">
                                  <div class="card shadow-sm p-3 col-12 mb-4">
                                    <div class="row">
                                      <label class="col-10 col-form-label">{{ item.name }}</label>
                                      <div class="col-2 switch-btn mt-3">
                                        <span class="switch switch-icon">
                                          <label>
                                            <div class="form-check form-switch form-check-custom form-check-solid">
                                              <input
                                                class="form-check-input h-20px w-30px"
                                                type="checkbox"
                                                :name="item.value"
                                                :value="item.value"
                                                v-model="item.checked"
                                                @change="setPermission(item.checked, item.value)"
                                                id="flexSwitchChecked"
                                              />
                                            </div>
                                          </label>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </Loader>
  </div>

</template>

<script setup>
import Loader from '@/components/Loader.vue'
import { useLocales } from '@/composables/locales'
import { computed, onMounted } from 'vue'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import {togglePermissionToUser} from "@/store/modules/role/actions";


const route = useRoute()
const store = useStore()
const {locale} = useLocales()

const user = ref({})
const userRoleAndPermissions = ref({})
const loading = ref(false)
const rights = ref([])

const allPermissions = computed(() => store.getters['permission/allPermissions'])


onMounted(async() => {
  await  store.dispatch("permission/loadAllPermissions")
  if(route.name === 'settings-users-permission-view'){
    await fetchData()
  }
})

async function fetchData() {
  loading.value = true
  store.dispatch("user/findUserById",route.params.id).then(response => {
    if (response.data) {
      let data = response.data
      let selected = response.data?.userRoleAndPermissions?.permissions || ''

      userRoleAndPermissions.value = data.userRoleAndPermissions
      user.value = data.user
      

      rights.value = allPermissions.value.map(mod => {
          return {
            name: locale.value == 'fr' ? mod?.sub_module_fr : mod?.sub_module_en,
            items: mod?.permissions?.map(el => ({
              name: el[locale.value],
              value: el.value,
              checked: selected.includes(el.value)
            }))
          }
      })
    }
  })
  .finally(() => loading.value = false)
 
}

function checkedInput($permission,arrayPermissions){
  return arrayPermissions.includes($permission)
}
    
function setPermission(val, name) {
  let data = {value: val, input: name}
  store.dispatch("role/togglePermissionToUser",{id: route.params.id, data: data})
  window.toastr['success'](i18n.global.t("notification.permission_added"))
}
  

</script>
